var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#125d38",
    d: "M5,20A2,2 0 0,0 7,22H17A2,2 0 0,0 19,20V7L14,2H7A2,2 0 0,0 5,4V20        M14,3.5L17.5,7H14V3.5        M10,14H14V12H10V14        M10,18H14V16H10V18        M10,10H14V8H10V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIco);
export default __webpack_public_path__ + "static/media/doc-ico.5167d73d3d5abec8fda3f8bf2f24fb51.svg";
export { ForwardRef as ReactComponent };